webpackJsonp([35783957827783],{

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var images = _ref.images,
	      deleteImage = _ref.deleteImage;
	  return _react2.default.createElement(
	    _semanticUiReact.Image.Group,
	    { size: 'tiny' },
	    images && images.map(function (img) {
	      return _react2.default.createElement(_semanticUiReact.Image, { key: img.name || img.filename, src: img.url || window.URL.createObjectURL(img),
	        label: deleteImage ? {
	          as: 'a',
	          corner: 'right',
	          icon: 'remove circle',
	          onClick: function onClick() {
	            return deleteImage(img);
	          }
	        } : null
	      });
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _semanticUiReact = __webpack_require__(28);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var indices = _ref.indices,
	      handleChange = _ref.handleChange,
	      files = _ref.files;
	  return _react2.default.createElement(
	    'div',
	    null,
	    indices.map(function (i) {
	      return _react2.default.createElement(
	        _semanticUiReact.Form.Group,
	        { key: i, style: { display: files.length === i ? 'block' : 'none' }, widths: 'equal' },
	        _react2.default.createElement(_semanticUiReact.Form.Field, {
	          name: 'files_' + i,
	          control: _semanticUiReact.Input,
	          type: 'file',
	          label: '\u4E0A\u4F20\u7968\u636E',
	          placeholder: '\u4E0A\u4F20\u7968\u636E',
	          onChange: handleChange
	        })
	      );
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _semanticUiReact = __webpack_require__(28);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ImagePreview = __webpack_require__(95);
	
	var _ImagePreview2 = _interopRequireDefault(_ImagePreview);
	
	var _FileSelect = __webpack_require__(542);
	
	var _FileSelect2 = _interopRequireDefault(_FileSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBlank(value) {
	  return value === '' || value === null;
	}
	
	exports.default = function (_ref) {
	  var howMuch = _ref.howMuch,
	      howLong = _ref.howLong,
	      refundMethod = _ref.refundMethod,
	      files = _ref.files,
	      scheme = _ref.scheme,
	      handleChange = _ref.handleChange,
	      gotoNextStep = _ref.gotoNextStep,
	      deleteImage = _ref.deleteImage;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('input', { type: 'hidden', name: 'userId' }),
	    _react2.default.createElement(
	      _semanticUiReact.Form.Field,
	      null,
	      _react2.default.createElement(
	        'label',
	        null,
	        '\u501F\u591A\u5C11'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Input,
	        { labelPosition: 'right', type: 'number', placeholder: '10000', name: 'howMuch', value: howMuch,
	          onChange: handleChange },
	        _react2.default.createElement(
	          _semanticUiReact.Label,
	          { basic: true },
	          '\uFFE5'
	        ),
	        _react2.default.createElement('input', null),
	        _react2.default.createElement(
	          _semanticUiReact.Label,
	          null,
	          '.00 \u5143'
	        )
	      )
	    ),
	    _react2.default.createElement('input', { type: 'hidden', name: 'howLong', value: howLong }),
	    _react2.default.createElement(_semanticUiReact.Form.Field, {
	      id: 'form-input-control-how-long',
	      control: _semanticUiReact.Select,
	      name: 'howLong',
	      label: '\u501F\u591A\u4E45',
	      placeholder: '24 \u6708',
	      value: howLong,
	      onChange: handleChange,
	      options: [{ key: 3, text: '三个月', value: 3 }, { key: 6, text: '六个月', value: 6 }, { key: 12, text: '一年', value: 12 }, { key: 24, text: '两年', value: 24 }, { key: 36, text: '三年', value: 36 }, { key: 48, text: '四年', value: 48 }, { key: 60, text: '五年', value: 60 }]
	    }),
	    _react2.default.createElement('input', { type: 'hidden', name: 'refundMethod', value: refundMethod }),
	    _react2.default.createElement(_semanticUiReact.Form.Field, {
	      id: 'form-input-control-refund',
	      control: _semanticUiReact.Select,
	      name: 'refundMethod',
	      label: '\u600E\u4E48\u8FD8',
	      placeholder: '\u7B49\u989D\u672C\u606F',
	      value: refundMethod,
	      onChange: handleChange,
	      options: [{
	        key: 0, text: '等额本息', value: 0
	      }, {
	        key: 1, text: '等额本金', value: 1
	      }, {
	        key: 2, text: '先息后本', value: 2
	      }]
	    }),
	    _react2.default.createElement(_FileSelect2.default, { files: files, indices: [0, 1, 2, 3, 4, 5, 6, 7, 8], handleChange: handleChange }),
	    _react2.default.createElement(
	      _semanticUiReact.Form.Field,
	      null,
	      _react2.default.createElement(_ImagePreview2.default, { images: files, deleteImage: deleteImage })
	    ),
	    _react2.default.createElement('input', { type: 'hidden', name: 'scheme', value: scheme }),
	    _react2.default.createElement(
	      _semanticUiReact.Form.Field,
	      {
	        id: 'form-button-control-public',
	        control: _semanticUiReact.Button,
	        color: 'red',
	        disabled: isBlank(howMuch) || isBlank(howLong) || isBlank(refundMethod),
	        onClick: gotoNextStep,
	        icon: true, labelPosition: 'right'
	      },
	      '\u4E0B\u4E00\u6B65',
	      _react2.default.createElement(_semanticUiReact.Icon, { name: 'right arrow' })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _semanticUiReact = __webpack_require__(28);
	
	var _constants = __webpack_require__(127);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = function (_ref) {
	  var scheme = _ref.scheme,
	      selectScheme = _ref.selectScheme;
	  return React.createElement(
	    _semanticUiReact.Card.Group,
	    { style: { marginBottom: '10px' } },
	    Object.keys(_constants.LoanSchemes).map(function (l) {
	      return React.createElement(_semanticUiReact.Card, { fluid: true, color: scheme === l ? 'red' : 'grey', header: _constants.LoanSchemes[l].name,
	        meta: Number(_constants.LoanSchemes[l].annual_interest) * 100 + ' %',
	        description: _constants.LoanSchemes[l].description,
	        onClick: function onClick(event) {
	          return selectScheme(event, l);
	        } });
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(28);
	
	__webpack_require__(121);
	
	var _LoanStep = __webpack_require__(543);
	
	var _LoanStep2 = _interopRequireDefault(_LoanStep);
	
	var _LoanStep3 = __webpack_require__(544);
	
	var _LoanStep4 = _interopRequireDefault(_LoanStep3);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _CheckUser = __webpack_require__(128);
	
	var _CheckUser2 = _interopRequireDefault(_CheckUser);
	
	var _loan = __webpack_require__(129);
	
	var _loan2 = _interopRequireDefault(_loan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var encode = function encode(data) {
	  var formData = new FormData();
	  Object.keys(data).map(function (key) {
	    if (key === 'files') {
	      var i = 0;
	      for (var _iterator = data[key], _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var file = _ref;
	
	        formData.append(key + '_' + i++, file, file.name);
	      }
	    } else {
	      formData.append(key, data[key]);
	    }
	  });
	  return formData;
	};
	
	var NewLoan = function (_React$Component) {
	  _inherits(NewLoan, _React$Component);
	
	  function NewLoan(props) {
	    _classCallCheck(this, NewLoan);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.publishNewLoan = _this.publishNewLoan.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.gotoNextStep = _this.gotoNextStep.bind(_this);
	    _this.selectScheme = _this.selectScheme.bind(_this);
	    _this.deleteImage = _this.deleteImage.bind(_this);
	
	    _this.state = {
	      howMuch: '',
	      howLong: '',
	      refundMethod: '',
	      files: [],
	      scheme: '',
	      step: 1
	    };
	    return _this;
	  }
	
	  NewLoan.prototype.handleChange = function handleChange(event, _ref2) {
	    var _this2 = this;
	
	    var name = _ref2.name,
	        value = _ref2.value;
	
	    if (!name.startsWith('files')) {
	      var _setState;
	
	      this.setState((_setState = {}, _setState[name] = value, _setState));
	    } else {
	      this.setState({
	        files: [].concat(this.state['files'], Array.from(event.target.files).filter(function (f) {
	          return _this2.state['files'].map(function (f) {
	            return f.name;
	          }).indexOf(f.name) < 0;
	        }))
	      });
	    }
	  };
	
	  NewLoan.prototype.deleteImage = function deleteImage(img) {
	    this.setState({
	      'files': this.state.files.filter(function (f) {
	        return f !== img;
	      })
	    });
	  };
	
	  NewLoan.prototype.gotoNextStep = function gotoNextStep(event) {
	    event.preventDefault();
	    this.setState({
	      step: this.state.step + 1
	    });
	  };
	
	  NewLoan.prototype.selectScheme = function selectScheme(event, scheme) {
	    event.preventDefault();
	    event.stopPropagation();
	
	    this.setState({
	      scheme: scheme,
	      allowSubmit: true
	    });
	  };
	
	  NewLoan.prototype.publishNewLoan = function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
	      var res, history;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!(typeof window === 'undefined')) {
	                _context.next = 2;
	                break;
	              }
	
	              return _context.abrupt('return');
	
	            case 2:
	              event.preventDefault();
	              _context.prev = 3;
	
	              this.setState({ loading: true });
	              _context.next = 7;
	              return window.fetch('/', {
	                method: 'POST',
	                body: encode(_extends({
	                  'form-name': 'loan'
	                }, this.state, {
	                  userId: _CheckUser2.default.getCurrentUser().id
	                }))
	              });
	
	            case 7:
	              res = _context.sent;
	
	
	              alert('发布成功');
	              _context.next = 11;
	              return _loan2.default.getHistory(_CheckUser2.default.getCurrentUser());
	
	            case 11:
	              history = _context.sent;
	
	              (0, _gatsbyLink.push)('/loan?loan_id=' + history[0].id);
	              _context.next = 18;
	              break;
	
	            case 15:
	              _context.prev = 15;
	              _context.t0 = _context['catch'](3);
	
	              console.error(_context.t0);
	
	            case 18:
	              _context.prev = 18;
	
	              this.setState({ loading: false });
	              return _context.finish(18);
	
	            case 21:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this, [[3, 15, 18, 21]]);
	    }));
	
	    function publishNewLoan(_x) {
	      return _ref3.apply(this, arguments);
	    }
	
	    return publishNewLoan;
	  }();
	
	  NewLoan.prototype.componentDidMount = function componentDidMount() {
	    _CheckUser2.default.init();
	    _CheckUser2.default.checkUser('/settings');
	  };
	
	  NewLoan.prototype.render = function render() {
	    return _react2.default.createElement(
	      _semanticUiReact.Form,
	      { name: 'loan', 'data-netlify': 'true', 'data-netlify-honeypot': 'bot-field', loading: this.state.loading,
	        onSubmit: this.publishNewLoan },
	      _react2.default.createElement(
	        'p',
	        { style: { display: 'none' } },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Don\u2019t fill this out if you\'re human: ',
	          _react2.default.createElement('input', { name: 'bot-field' })
	        )
	      ),
	      this.state.step === 1 && _react2.default.createElement(_LoanStep2.default, { howMuch: this.state.howMuch, howLong: this.state.howLong, refundMethod: this.state.refundMethod,
	        files: this.state['files'],
	        scheme: this.state.scheme,
	        deleteImage: this.deleteImage,
	        handleChange: this.handleChange, gotoNextStep: this.gotoNextStep }),
	      this.state.step === 2 && _react2.default.createElement(_LoanStep4.default, { scheme: this.state.scheme, selectScheme: this.selectScheme }),
	      this.state.step === 2 && _react2.default.createElement(_semanticUiReact.Form.Field, {
	        color: 'red',
	        id: 'form-button-control-submit',
	        control: _semanticUiReact.Button,
	        content: '\u63D0\u4EA4',
	        disabled: !this.state.allowSubmit
	      })
	    );
	  };
	
	  return NewLoan;
	}(_react2.default.Component);
	
	exports.default = NewLoan;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-75d188fd1c6ca9532eac.js